import React from 'react';
import { COM_COLORS } from '../utils/constants';
import { fmtUnit } from '../utils/helpers';
import { MiniPct } from './ProjetSection';
import InfoTip from './InfoTip';

// unit : respecte le sélecteur d'unité de la section parente (montants uniquement, pas les compteurs)

const CommercialKpiCard = ({ item, idx, onVentesClick, onRecClick, onPnClick, unit }) => {
  const color = COM_COLORS[idx % COM_COLORS.length];
  const rows = [
    { label: 'Vente',  info: 'CA Ventes réalisé par ce commercial : lots directs + parts d\'associations dans la période. Le nombre de contrats est affiché en petit.', budget: item.budgetVente, real: item.caVentes,  pct: item.pctVente, nb: item.nbVentes, color: '#6d4e36', onClick: onVentesClick },
    { label: 'Recouv', info: 'Encaissements supplémentaires (enc_supp = 1) sur les contrats de ce commercial dans la période.', budget: item.budgetRec,   real: item.realisRec, pct: item.pctRec,   nb: null,          color: '#2e7d32', onClick: onRecClick },
    { label: 'PN',     info: 'Montant des passages notaire sur les contrats de ce commercial dans la période sélectionnée.', budget: item.budgetPn,    real: item.realisPn,  pct: item.pctPn,    nb: item.nbPn,     color: '#6a1b9a', onClick: onPnClick },
  ];
  return (
    <div style={{ border: `2px solid ${color}`, borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.07)', background: '#fdfcf7', padding: '0.75rem', display: 'flex', flexDirection: 'column', gap: 6 }}>
      <div style={{ fontWeight: 700, color, fontSize: '0.82rem', textAlign: 'center', marginBottom: 2 }}>
        👤 {item.commercial || '—'}
      </div>
      {rows.map(({ label, info, budget, real, pct: pctVal, nb, color: rc, onClick }) => (
        <div key={label} style={{ background: '#fff', borderRadius: 7, border: '1px solid #ece7e0', padding: '5px 9px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
            <span style={{ fontSize: '0.65rem', fontWeight: 700, color: '#aaa', textTransform: 'uppercase', letterSpacing: 0.5, display: 'flex', alignItems: 'center' }}>{label}<InfoTip text={info} /></span>
            <MiniPct pctVal={pctVal} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
            <span style={{ fontSize: '0.88rem', fontWeight: 700, color: rc, cursor: onClick ? 'pointer' : 'default', textDecoration: onClick ? 'underline dotted' : 'none' }}
              onClick={onClick} title={onClick ? 'Voir le détail' : undefined}>
              {fmtUnit(real, unit)}
              {nb != null && <span style={{ fontSize: '0.62rem', fontWeight: 400, color: '#bbb', marginLeft: 4 }}>{nb} ct</span>}
            </span>
            {budget > 0 && <span style={{ fontSize: '0.65rem', color: '#bbb' }}>/ {fmtUnit(budget, unit)}</span>}
          </div>
          {budget > 0 && (
            <div style={{ marginTop: 4, height: 3, borderRadius: 2, background: '#ece7e0', overflow: 'hidden' }}>
              <div style={{ height: '100%', borderRadius: 2, background: rc, width: `${Math.min(100, Math.round((real / budget) * 100))}%`, transition: 'width 0.4s ease' }} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CommercialKpiCard;
